import { render, staticRenderFns } from "./WidgetHeader.vue?vue&type=template&id=d29b864c&scoped=true"
import script from "./WidgetHeader.vue?vue&type=script&lang=js"
export * from "./WidgetHeader.vue?vue&type=script&lang=js"
import style0 from "./WidgetHeader.vue?vue&type=style&index=0&id=d29b864c&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d29b864c",
  null
  
)

export default component.exports